export default __webpack_public_path__ + "static/media/streak-tier-4.22746dec.png";